import type {
  ShopFeatureFlagId,
  ShopFeatureFlags,
} from "@/modules/merchant/domain/contracts/shop-feature-flags";
import { isShopFeatureEnabled } from "@/modules/merchant/domain/contracts/shop-feature-flags";

export function hasShopFeature(
  flags: ShopFeatureFlags | null | undefined,
  key: ShopFeatureFlagId,
): boolean {
  return isShopFeatureEnabled(flags ?? null, key);
}
